// Înregistrăm service worker-ul doar pe build-ul de producție (pe dev server ar cache-ui greșit).
export const registerServiceWorker = () => {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      // La un deploy nou activăm imediat versiunea nouă, fără reload forțat.
      reg.addEventListener('updatefound', () => {
        const next = reg.installing;
        if (!next) return;
        next.addEventListener('statechange', () => {
          if (next.state === 'installed' && navigator.serviceWorker.controller) {
            next.postMessage('SKIP_WAITING');
          }
        });
      });
    }).catch(() => {});
  });
};

export default registerServiceWorker;
